import { Paper } from "@mui/material";
import PropTypes from "prop-types";

/**
 * ContentCard
 * Standardized Paper wrapper to keep consistent padding, elevation, and radius.
 */
export default function ContentCard({ children, sx = {}, elevation = 1, p = 2, ...paperProps }) {
  return (
    <Paper
      elevation={elevation}
      sx={{
        p,
        borderRadius: "12px",
        ...sx,
      }}
      {...paperProps}
    >
      {children}
    </Paper>
  );
}

ContentCard.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
  elevation: PropTypes.number,
  p: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
